import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-nigeria-blue-blossom.component.scss';
var FormItemNigeriaBlueBlossom = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemNigeriaBlueBlossom, _super);
    function FormItemNigeriaBlueBlossom(element) {
        return _super.call(this, element) || this;
    }
    FormItemNigeriaBlueBlossom.prototype.init = function () {
        smartech('create', 'ADGMOT35CHFLVDHBJNIG50K968ED363VT99PES8C9O373MQRCS70');
        smartech('register', 'c32c1945e67e387c899e5faf0cf5342a');
        smartech('identify', '');
        this.form = this.element.querySelector('form');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-submit__blue-blossom'));
        this.inputEarner = Array.from(this.element.querySelectorAll('.js-radio-group-earner'));
        this.containerOther = this.element.querySelector('.js-other-container');
        if (this.element.closest('.modal')) {
            this.modal = this.element.closest('.modal');
        }
        // js-apply-now-modal-close
        // modal
        this.varGender = 'male';
        this.varEarner = 'Salary Earner';
        this.varEarner = '18-25';
    };
    FormItemNigeriaBlueBlossom.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
                var formFields = _this.form.querySelectorAll('input, select, textarea');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.action(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
                }
            }); });
        }
        if (this.inputEarner) {
            this.inputEarner.map(function (item) { return item.addEventListener('click', function (event) {
                var element = undefined;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                if (element.value === 'other') {
                    _this.containerOther.classList.remove('d-none');
                    var inputOther = _this.containerOther.querySelector('input[name=other]');
                    inputOther.classList.add('form__input--required');
                }
                else {
                    _this.containerOther.classList.add('d-none');
                    var inputOther = _this.containerOther.querySelector('input[name=other]');
                    inputOther.classList.remove('form__input--required');
                }
            }); });
        }
        if (this.modal) {
            this.modal.addEventListener('click', function (event) {
                var element = event.target;
                if (element.classList.contains('modal')) {
                    _this.containerOther.classList.add('d-none');
                    var inputOther = _this.containerOther.querySelector('input[name=other]');
                    inputOther.classList.remove('form__input--required');
                }
            });
            if (this.modal.querySelector('.modal__close')) {
                var closeModalButton = this.modal.querySelector('.modal__close');
                closeModalButton.addEventListener('click', function (event) {
                    _this.containerOther.classList.add('d-none');
                    var inputOther = _this.containerOther.querySelector('input[name=other]');
                    inputOther.classList.remove('form__input--required');
                });
            }
        }
    };
    FormItemNigeriaBlueBlossom.prototype.action = function (form, loader, thankyou) {
        // fields
        var emailAddress = form.querySelector('input[name=emailAddress');
        var firstName = form.querySelector('input[name=first-name]');
        var surname = form.querySelector('input[name=surname]');
        var phone = form.querySelector('input[name=phone]');
        var location = form.querySelector('input[name=location]');
        var gender = Array.from(form.querySelectorAll('input[name=gender]'));
        var age = Array.from(form.querySelectorAll('input[name=age]'));
        var salary = Array.from(form.querySelectorAll('input[name=salary]'));
        var genderBracket = '';
        var ageBracket = '';
        var salaryBracket = '';
        gender.map(function (input) {
            if (input.checked) {
                genderBracket = input.value;
            }
        });
        age.map(function (input) {
            if (input.checked) {
                ageBracket = input.value;
            }
        });
        salary.map(function (input) {
            if (input.checked) {
                if (input.value === 'other') {
                    var otherField = form.querySelector('input[name=other]');
                    salaryBracket = otherField.value;
                }
                else {
                    salaryBracket = input.value;
                }
            }
        });
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // identity
        smartech('identify', emailAddress.value);
        // create contact in netcore
        smartech('contact', 2476, {
            'pk^email': emailAddress.value,
            'mobile': phone.value,
            'FIRST_NAME': firstName.value,
            'LAST_NAME': surname.value,
            'AGE': ageBracket,
            'GENDER': genderBracket,
            'LOCATION': location.value
        }),
            // dispatch to netcore
            smartech('dispatch', ' blue_blossom_campaign', {
                "email": emailAddress.value,
                "firstname": firstName.value,
                "lastname": surname.value,
                "age": ageBracket,
                "gender": genderBracket,
                "location": location.value,
                "salary": salaryBracket
            });
        loader.classList.remove('active');
        thankyou.classList.add('active');
    };
    return FormItemNigeriaBlueBlossom;
}(Base));
export { FormItemNigeriaBlueBlossom };



//////////////////
// WEBPACK FOOTER
// ./components-nigeria/form-item-nigeria-blue-blossom/form-item-nigeria-blue-blossom.component.ts
// module id = 710
// module chunks = 0